import React, { useState } from "react";
import { Button, Tab } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { ListSubject, SubjectForm } from "../../../components/Admin/Subject";
import "./Subject.scss";

export function Subject() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListSubject reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="subject-page">
        <Button className="subject-page__add" primary onClick={onOpenCloseModal}>
          Nueva asignatura
        </Button>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title="Crear asignatura">
        <SubjectForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
